// src/pages/Chat/MessagePage.jsx
import React from "react";
import { useLocation } from "react-router-dom";
import ChatSidebar from "../../components/chat/ChatSidebar";
import ChatWindow from "../../components/chat/ChatWindow";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}


export default function MessagePage() {
  const query = useQuery();
  const otherUserId = Number(query.get("withUserId")) || null;
  const listingId = Number(query.get("listingId")) || null;

  return (
    <div className="max-w-7xl mx-auto px-6 py-2 grid grid-cols-12 gap-4">
      <div className="col-span-4 border-r">
        <ChatSidebar />
      </div>
      <div className="col-span-8">
        <ChatWindow otherUserId={otherUserId} listingId={listingId} />
      </div>
    </div>
  );
}
